module.exports = __webpack_public_path__ + "media/images/city_img/s_2-7dbb1ac030037f40d0db7bfe1854d044.png";